import { Select } from "antd";
import styled from "styled-components";

export const StyledSelect = styled(Select)`
  border-radius: 3px;
  min-width: 180px;
  background: #333336;
  border: 1px solid var(--topup-recharge-input-border);
  &:hover,
  &:active {
    box-shadow: 0 0 0 1px var(--main-color);
  }
  &.ant-select-single.ant-select-open .ant-select-selection-item,
  .ant-select-selection-placeholder {
    color: #b7b7b7 !important;
  }
  .ant-select-selector {
    background: #333336 !important;
    border: 0 !important;
  }
  .ant-select-selection-search {
    color: rgba(255, 255, 255, 0.85) !important;
  }
  .ant-select-arrow {
    color: rgba(255, 255, 255, 0.62);
  }
  .ant-select-clear {
    color: rgba(255, 255, 255, 0.62);
    background-color: #333336;
  }
  .ant-select-dropdown {
    background: #333336;
    color: rgba(255, 255, 255, 0.85);
    border-radius: 0;
    padding: 0;
  }
  .ant-empty-description {
    color: rgba(255, 255, 255, 0.85);
  }
  .ant-select-item-option {
    padding: 7px 12px;
    border-radius: 0;
  }
  .ant-select-item-option {
    &-active:not(.ant-select-item-option-disabled),
    &-selected:not(.ant-select-item-option-disabled) {
      background: var(--main-color) !important;
    }
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background: #333336;
  }
  &.ant-select.ant-select-show-search {
    .ant-select-arrow {
      opacity: 1;
    }
  }
`;
